import * as s from './Navigation.scss';
import { LanguagesIcon } from '../../LanguagePicker/LanguagesIcon';
import { constants } from '../../../data/languages';
import { DropdownArrow } from './DropdownArrow/DropdownArrow';
import { setLanguageUrl } from '../../../utils/languageUrl';

export const languageMenuItemData = {
  text: 'menu_languages',
  name: 'languages',
  id: 'main-menu-item-languages',
  subs: constants.languages.map((language) => ({
    ...language,
    href: setLanguageUrl({
      language: language.name || '',
      location: typeof window !== 'undefined' ? window.location : null,
    }),
  })),
};

interface LanguagesProps {
  language: string;
}

export const Languages = ({ language }: LanguagesProps) => {
  const { name, id, subs } = languageMenuItemData;
  return `
    <li class="${s.menuItem} ${s.languages}">
      <div class="${s.linkWrapper} ${s.desktopOnly}">
        <a
          class="${s.link}"
          data-hook="language-picker"
          data-bi-name="${name}"
          data-bi-row="first"
          role="button"
          href="#"
        >
          ${LanguagesIcon(s.iconLanguages)}
          <span class="${s.iconText}">${language.toUpperCase()}</span>
      </a>
      </div>
      <div class="${s.linkWrapper} ${s.mobileOnly}">
        <a
          id="${id}"
          class="${s.link} ${s.mobileOnly}"
          data-bi-name="${name}"
          data-bi-row="first"
          data-toggle="collapse"
          aria-expanded="false"
          role="button"
          href="#"
        >
          ${LanguagesIcon(s.iconLanguages)}
          <span class="${s.iconText}">${language.toUpperCase()}</span>
          ${subs.length ? DropdownArrow(s.arrow) : ''}
        </a>
      </div>
      <div class="${s.mobileOnly}" data-hook="wix-header-language-submenu-wrapper">
      </div>
    </li>
  `;
};
